import ReactGA from 'react-ga';

export const gaPageView = (view) => () => {
  // eslint-disable-line
  if (process.env.GA_ENABLED) {
    ReactGA.pageview(view);
  }
};

export const gaSend = ({ category, action, label }) => () => {
  // eslint-disable-line
  if (process.env.GA_ENABLED) {
    ReactGA.ga('send', 'event', category, action, label);
  }
};



// WEBPACK FOOTER //
// ./action-creators/services.js